export const playCopy = {
  play_subnav_title: "Playground",
  play_subnav_config: "TS Config",
  play_config_language_blurb: "Qual idioma deve ser usado no editor",
  play_subnav_examples: "Exemplos",
  play_subnav_examples_close: "Fechar",
  play_subnav_whatsnew: "Novidades",
  play_subnav_settings: "Configurações",
  play_settings_tabs_settings: "Abas da barra lateral",
  play_downloading_typescript: "Baixando TypeScript...", // quando carregando
  play_downloading_version: "Versão...", // quando carregando
  play_toolbar_run: "Rodar",
  play_toolbar_export: "Exportar",
  play_sidebar_js: ".JS",
  play_sidebar_dts: ".D.TS",
  play_sidebar_errors: "Erros",
  play_sidebar_errors_no_errors: "Sem erros",
  play_sidebar_logs: "Logs",
  play_sidebar_logs_no_logs: "Sem logs",
  play_sidebar_options: "Opções",
  play_sidebar_options_restart_required: "Atualização do navegador necessária",
  play_sidebar_options_disable_ata: "Desabilita ATA",
  play_sidebar_options_disable_ata_copy:
    "Desabilita a aquisição automática de tipos para 'imports' e 'requires'.",
  play_sidebar_options_disable_save: "Desabilita Salvar-Ao-Digitar",
  play_sidebar_options_disable_save_copy:
    "Desabilita a alteração da URL ao digitar.",
  play_sidebar_plugins: "Plugins",
  play_sidebar_featured_plugins: "Plugins em Destaque",
  play_sidebar_plugins_options_external:
    "Plugins de Terceiros <a href='https://www.npmjs.com/search?q=keywords:playground-plugin'>do npm</a>",
  play_sidebar_plugins_options_external_warning:
    "Atenção: O código dos plugins vem de terceiros.",
  play_sidebar_plugins_options_modules: "Módulos npm personalizados",
  play_sidebar_plugins_options_modules_placeholder: "Nome do módulo do npm.",
  play_sidebar_plugins_plugin_dev: "Plugin Dev",
  play_sidebar_plugins_plugin_dev_option:
    "Conectar a <code>localhost:5000</code>",
  play_sidebar_plugins_plugin_dev_copy:
    "Tente conectar-se automaticamente a um plugin de playground no modo de desenvolvimento. Você pode começar a <a href='/dev/playground-plugins/' title='Link para a página sobre plugins do Playground'>fazer um plugin aqui</a>",
  play_export_report_issue: "Relatar 'Issue' do TypeScript no GitHub",
  play_export_copy_md: "Copiar Como 'Issue Markdown'",
  play_export_copy_link: "Copiar Como 'Link Markdown'",
  play_export_copy_link_preview: "Copiar como 'Link Markdown com visualização'",
  play_export_tsast: "Abrir no 'TypeScript AST Viewer'",
  play_export_bugworkbench: "Abrir no 'Bug Workbench'",
  play_export_sandbox: "Abrir no CodeSandbox",
  play_export_stackblitz: "Abrir no StackBlitz",
  play_export_clipboard: "[URL copiado para a área de transferência]",
  play_run_js: "JavaScript Executado",
  play_run_ts: "TypeScript Transpilado Executado",
  play_run_js_fail: "O JavaScript Executado Falhou:",
  play_default_code_sample: `// Bem-vindo ao TypeScript Playground, este é um site
// que lhe dá a chance de escrever, compartilhar e aprender TypeScript.

// Você pode pensar nisso de três maneiras:
//
//  - Um lugar para aprender TypeScript onde nada pode quebrar
//  - Um lugar para experimentar a sintaxe TypeScript e compartilhar as URLs com outras pessoas
//  - Uma sandbox para experimentar diferentes recursos do compilador do TypeScript

const umExemploDeVariavel = "Hello World"
console.log(umExemploDeVariavel)

// Para saber mais sobre a linguagem, clique acima em "Exemplos" ou "Novidades".
// Caso contrário, comece removendo esses comentários e o mundo será seu playground.
  `,

  play_sidebar_js_title: "JavaScript",
  play_sidebar_js_blurb: "Mostra o JS transpilado",

  play_sidebar_dts_title: "Arquivos de definição",
  play_sidebar_dts_blurb: "Mostra a saída .d.ts do seu código",

  play_sidebar_err_title: "Erros do compilador",
  play_sidebar_err_blurb: "Mostra erros do compilador por completo",

  play_sidebar_run_title: "Executar o JavaScript no navegador",
  play_sidebar_run_blurb: "Mostra a saída da execução do JavaScript no editor",

  play_sidebar_plugins_title: "Gerenciar plug-ins do Playground",
  play_sidebar_plugins_blurb:
    "Lida com a adição / remoção de extensões de terceiros para o playground",

  play_sidebar_ast_title: "[WIP] AST Viwer",
  play_sidebar_ast_blurb: "Inspecione o TypeScript AST",

  // Observação:
  // As informações das flags do compilador vêm todas das informações de referência do tsconfig
}
